// Providers and Location Search
export const ZIP_CODE = 'zipCode';
export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const ADDRESS = 'address';

export const OASContextError =
  'useOASLandingSearchContext must be used within a OASLandingSearch provider!';

export const VALID_SEARCH_REGEX = /^[a-zA-Z0-9()–',.&\s/\\-]+$/;

export const DEFAULT_DEBOUNCE_TIME = 250;
export const DEFAULT_EXPAND_AT = 3;
export const MAX_CHARS_INPUT = 255;

export const SEARCH_MIN_CHARS = 3;
export const BLUR_DEBOUNCE_MS = 250;
export const DEBOUNCE_LIMIT_150 = 150;
export const DEBOUNCE_LIMIT_300 = 300;

export const MIN_PHYSICIANS_COUNT = 20;
